import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Paper,
  Button,
  TextField,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Badge,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import BuildIcon from '@mui/icons-material/Build';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WarningIcon from '@mui/icons-material/Warning';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment';

const WorkOrder = () => {
  const [tabValue, setTabValue] = useState(0);
  const [workOrders, setWorkOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [statusUpdate, setStatusUpdate] = useState('');
  const [comments, setComments] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [loading, setLoading] = useState(true);
  
  // 模擬加載工作訂單數據
  useEffect(() => {
    // 這裡將是API調用
    setTimeout(() => {
      const mockWorkOrders = [
        {
          id: 1,
          type: 'plumbing',
          title: '廚房水管漏水',
          description: '廚房水槽下方的水管有滴水現象，需要維修',
          status: 'pending',
          priority: 'high',
          location: 'A棟1201室',
          reporter: '陳大文',
          contactPhone: '98765432',
          createdAt: '2023-06-19T09:30:00',
          updatedAt: '2023-06-19T09:30:00',
          images: ['leak1.jpg', 'leak2.jpg'],
          assignedTo: '',
          timeline: [
            {
              status: 'reported',
              timestamp: '2023-06-19T09:30:00',
              comments: '住戶報告廚房漏水問題'
            }
          ]
        },
        {
          id: 2,
          type: 'electrical',
          title: '客廳燈具故障',
          description: '客廳的主燈時亮時滅，懷疑是電線接觸不良',
          status: 'in_progress',
          priority: 'medium',
          location: 'B棟0802室',
          reporter: '黃麗華',
          contactPhone: '91234567',
          createdAt: '2023-06-18T14:20:00',
          updatedAt: '2023-06-19T10:15:00',
          images: ['light1.jpg'],
          assignedTo: '王技術員',
          timeline: [
            {
              status: 'reported',
              timestamp: '2023-06-18T14:20:00',
              comments: '住戶報告燈具故障'
            },
            {
              status: 'in_progress',
              timestamp: '2023-06-19T10:15:00',
              comments: '已安排王技術員前往維修，預計今天下午到達'
            }
          ]
        },
        {
          id: 3,
          type: 'hvac',
          title: '冷氣不製冷',
          description: '主臥室冷氣開啟後不製冷，只吹風',
          status: 'scheduled',
          priority: 'medium',
          location: 'C棟0505室',
          reporter: '林美玲',
          contactPhone: '90123456',
          createdAt: '2023-06-17T11:45:00',
          updatedAt: '2023-06-19T09:00:00',
          images: [],
          assignedTo: '冷氣維修公司',
          scheduledDate: '2023-06-22T14:00:00',
          timeline: [
            {
              status: 'reported',
              timestamp: '2023-06-17T11:45:00',
              comments: '住戶報告冷氣不製冷'
            },
            {
              status: 'scheduled',
              timestamp: '2023-06-19T09:00:00',
              comments: '已安排冷氣維修公司於6月22日下午2點前往維修'
            }
          ]
        },
        {
          id: 4,
          type: 'locksmith',
          title: '門鎖更換',
          description: '大門鎖損壞，需要更換新鎖',
          status: 'completed',
          priority: 'high',
          location: 'A棟1503室',
          reporter: '王建國',
          contactPhone: '92345678',
          createdAt: '2023-06-15T16:30:00',
          completedAt: '2023-06-16T11:20:00',
          images: ['lock1.jpg'],
          assignedTo: '李維修',
          timeline: [
            {
              status: 'reported',
              timestamp: '2023-06-15T16:30:00',
              comments: '住戶報告門鎖損壞'
            },
            {
              status: 'in_progress',
              timestamp: '2023-06-16T09:30:00',
              comments: '已安排李維修前往更換門鎖'
            },
            {
              status: 'completed',
              timestamp: '2023-06-16T11:20:00',
              comments: '門鎖已更換完成，住戶已確認'
            }
          ]
        },
        {
          id: 5,
          type: 'pest_control',
          title: '蟑螂防治',
          description: '廚房發現多隻蟑螂，需要進行滅蟲處理',
          status: 'completed',
          priority: 'low',
          location: 'B棟1202室',
          reporter: '李小明',
          contactPhone: '93456789',
          createdAt: '2023-06-14T10:10:00',
          completedAt: '2023-06-15T15:45:00',
          images: [],
          assignedTo: '安心滅蟲公司',
          timeline: [
            {
              status: 'reported',
              timestamp: '2023-06-14T10:10:00',
              comments: '住戶報告蟑螂問題'
            },
            {
              status: 'scheduled',
              timestamp: '2023-06-14T14:30:00',
              comments: '已安排安心滅蟲公司於6月15日下午進行處理'
            },
            {
              status: 'completed',
              timestamp: '2023-06-15T15:45:00',
              comments: '滅蟲工作已完成，並提供了預防建議給住戶'
            }
          ]
        }
      ];
      
      setWorkOrders(mockWorkOrders);
      setFilteredOrders(mockWorkOrders);
      setLoading(false);
    }, 1000);
  }, []);
  
  // 處理標籤切換
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  
  // 過濾工作訂單
  useEffect(() => {
    let result = workOrders;
    
    // 根據標籤過濾
    switch (tabValue) {
      case 0: // 所有工作
        result = workOrders;
        break;
      case 1: // 待處理
        result = workOrders.filter(order => order.status === 'pending');
        break;
      case 2: // 進行中
        result = workOrders.filter(order => 
          order.status === 'in_progress' || 
          order.status === 'scheduled'
        );
        break;
      case 3: // 已完成
        result = workOrders.filter(order => order.status === 'completed');
        break;
      default:
        result = workOrders;
    }
    
    // 搜索詞過濾
    if (searchTerm) {
      result = result.filter(order => 
        order.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.reporter.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // 類型過濾
    if (filterType !== 'all') {
      result = result.filter(order => order.type === filterType);
    }
    
    // 狀態過濾
    if (filterStatus !== 'all') {
      result = result.filter(order => order.status === filterStatus);
    }
    
    setFilteredOrders(result);
  }, [tabValue, searchTerm, filterType, filterStatus, workOrders]);
  
  // 打開工作訂單詳情對話框
  const handleOpenDialog = (order) => {
    setSelectedOrder(order);
    setDialogOpen(true);
  };
  
  // 關閉工作訂單詳情對話框
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  
  // 打開更新對話框
  const handleOpenUpdateDialog = () => {
    setDialogOpen(false);
    setUpdateDialogOpen(true);
    setStatusUpdate(selectedOrder.status);
  };
  
  // 關閉更新對話框
  const handleCloseUpdateDialog = () => {
    setUpdateDialogOpen(false);
    setComments('');
  };
  
  // 更新工作訂單狀態
  const handleUpdateOrder = () => {
    // 如果狀態沒有變化且沒有評論，則不做任何更新
    if (statusUpdate === selectedOrder.status && !comments.trim()) return;
    
    // 這裡將是API調用
    const updatedOrders = workOrders.map(order => {
      if (order.id === selectedOrder.id) {
        const timeline = [...order.timeline];
        
        // 如果狀態有變化，添加到時間線
        if (statusUpdate !== order.status) {
          timeline.push({
            status: statusUpdate,
            timestamp: moment().format(),
            comments: comments || `狀態從 ${getStatusName(order.status)} 更改為 ${getStatusName(statusUpdate)}`
          });
        }
        // 如果只有評論，也添加到時間線
        else if (comments.trim()) {
          timeline.push({
            status: order.status,
            timestamp: moment().format(),
            comments: comments
          });
        }
        
        const updatedOrder = {
          ...order,
          status: statusUpdate,
          updatedAt: moment().format(),
          timeline
        };
        
        // 如果標記為完成，添加完成時間
        if (statusUpdate === 'completed' && order.status !== 'completed') {
          updatedOrder.completedAt = moment().format();
        }
        
        return updatedOrder;
      }
      return order;
    });
    
    setWorkOrders(updatedOrders);
    setUpdateDialogOpen(false);
    setComments('');
  };
  
  // 獲取工作類型名稱
  const getWorkTypeName = (type) => {
    switch (type) {
      case 'plumbing':
        return '水電維修';
      case 'electrical':
        return '電氣維修';
      case 'hvac':
        return '冷暖空調';
      case 'locksmith':
        return '門鎖維修';
      case 'pest_control':
        return '害蟲防治';
      case 'general':
        return '一般維修';
      default:
        return type;
    }
  };
  
  // 獲取狀態名稱
  const getStatusName = (status) => {
    switch (status) {
      case 'pending':
        return '待處理';
      case 'in_progress':
        return '處理中';
      case 'scheduled':
        return '已排程';
      case 'completed':
        return '已完成';
      case 'cancelled':
        return '已取消';
      default:
        return status;
    }
  };
  
  // 獲取狀態芯片
  const getStatusChip = (status) => {
    switch (status) {
      case 'pending':
        return <Chip size="small" label="待處理" color="warning" />;
      case 'in_progress':
        return <Chip size="small" label="處理中" color="primary" />;
      case 'scheduled':
        return <Chip size="small" label="已排程" color="info" />;
      case 'completed':
        return <Chip size="small" label="已完成" color="success" icon={<CheckCircleIcon />} />;
      case 'cancelled':
        return <Chip size="small" label="已取消" color="default" />;
      default:
        return <Chip size="small" label={status} />;
    }
  };
  
  // 獲取優先級芯片
  const getPriorityChip = (priority) => {
    switch (priority) {
      case 'high':
        return <Chip size="small" label="高" color="error" />;
      case 'medium':
        return <Chip size="small" label="中" color="warning" />;
      case 'low':
        return <Chip size="small" label="低" color="info" />;
      default:
        return <Chip size="small" label={priority} />;
    }
  };
  
  return (
    <Box>
      <Typography variant="h5" gutterBottom>工作訂單管理</Typography>
      
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab 
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <span>所有工作</span>
                <Chip 
                  size="small" 
                  label={workOrders.length} 
                  sx={{ ml: 1, height: 20, minWidth: 20 }} 
                />
              </Box>
            } 
          />
          <Tab 
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <span>待處理</span>
                <Badge 
                  badgeContent={workOrders.filter(o => o.status === 'pending').length} 
                  color="warning"
                  sx={{ ml: 1 }}
                />
              </Box>
            } 
          />
          <Tab 
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <span>進行中</span>
                <Badge 
                  badgeContent={
                    workOrders.filter(o => 
                      o.status === 'in_progress' || 
                      o.status === 'scheduled'
                    ).length
                  } 
                  color="primary"
                  sx={{ ml: 1 }}
                />
              </Box>
            } 
          />
          <Tab 
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <span>已完成</span>
                <Badge 
                  badgeContent={workOrders.filter(o => o.status === 'completed').length} 
                  color="success"
                  sx={{ ml: 1 }}
                />
              </Box>
            } 
          />
        </Tabs>
      </Paper>
      
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label="搜索標題/地點/報告人"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>工作類型</InputLabel>
              <Select
                value={filterType}
                label="工作類型"
                onChange={(e) => setFilterType(e.target.value)}
              >
                <MenuItem value="all">所有類型</MenuItem>
                <MenuItem value="plumbing">水電維修</MenuItem>
                <MenuItem value="electrical">電氣維修</MenuItem>
                <MenuItem value="hvac">冷暖空調</MenuItem>
                <MenuItem value="locksmith">門鎖維修</MenuItem>
                <MenuItem value="pest_control">害蟲防治</MenuItem>
                <MenuItem value="general">一般維修</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>狀態</InputLabel>
              <Select
                value={filterStatus}
                label="狀態"
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <MenuItem value="all">所有狀態</MenuItem>
                <MenuItem value="pending">待處理</MenuItem>
                <MenuItem value="in_progress">處理中</MenuItem>
                <MenuItem value="scheduled">已排程</MenuItem>
                <MenuItem value="completed">已完成</MenuItem>
                <MenuItem value="cancelled">已取消</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button 
              variant="outlined" 
              fullWidth
              startIcon={<FilterListIcon />}
              onClick={() => {
                setSearchTerm('');
                setFilterType('all');
                setFilterStatus('all');
              }}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </Paper>
      
      {loading ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography>載入中...</Typography>
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>標題</TableCell>
                <TableCell>類型</TableCell>
                <TableCell>位置</TableCell>
                <TableCell>申請人</TableCell>
                <TableCell>提交時間</TableCell>
                <TableCell>狀態</TableCell>
                <TableCell>優先級</TableCell>
                <TableCell>操作</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredOrders.length > 0 ? (
                filteredOrders.map((order) => (
                  <TableRow 
                    key={order.id}
                    hover
                    onClick={() => handleOpenDialog(order)}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell>#{order.id}</TableCell>
                    <TableCell>{order.title}</TableCell>
                    <TableCell>{getWorkTypeName(order.type)}</TableCell>
                    <TableCell>{order.location}</TableCell>
                    <TableCell>{order.reporter}</TableCell>
                    <TableCell>{moment(order.createdAt).format('MM/DD HH:mm')}</TableCell>
                    <TableCell>{getStatusChip(order.status)}</TableCell>
                    <TableCell>{getPriorityChip(order.priority)}</TableCell>
                    <TableCell>
                      <IconButton 
                        size="small" 
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenDialog(order);
                        }}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    沒有找到工作訂單
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      
      {/* 工作訂單詳情對話框 */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        {selectedOrder && (
          <>
            <DialogTitle>
              <Typography variant="h6">
                工作訂單 #{selectedOrder.id}: {selectedOrder.title}
              </Typography>
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={3}>
                <Grid item xs={12} md={7}>
                  <Box sx={{ mb: 3 }}>
                    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                      {getStatusChip(selectedOrder.status)}
                      {getPriorityChip(selectedOrder.priority)}
                      <Chip 
                        size="small" 
                        label={getWorkTypeName(selectedOrder.type)} 
                        color="default" 
                      />
                    </Stack>
                    
                    <Typography variant="subtitle1" gutterBottom>
                      詳細描述
                    </Typography>
                    <Paper variant="outlined" sx={{ p: 2 }}>
                      <Typography variant="body1" paragraph>
                        {selectedOrder.description}
                      </Typography>
                    </Paper>
                  </Box>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <LocationOnIcon color="primary" sx={{ mr: 1, mt: 0.5 }} />
                          <Box>
                            <Typography variant="subtitle2" gutterBottom>
                              位置
                            </Typography>
                            <Typography variant="body2">
                              {selectedOrder.location}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <PersonIcon color="primary" sx={{ mr: 1, mt: 0.5 }} />
                          <Box>
                            <Typography variant="subtitle2" gutterBottom>
                              申請人
                            </Typography>
                            <Typography variant="body2">
                              {selectedOrder.reporter}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              聯絡電話: {selectedOrder.contactPhone}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <CalendarTodayIcon color="primary" sx={{ mr: 1, mt: 0.5 }} />
                          <Box>
                            <Typography variant="subtitle2" gutterBottom>
                              提交時間
                            </Typography>
                            <Typography variant="body2">
                              {moment(selectedOrder.createdAt).format('YYYY/MM/DD HH:mm')}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined" sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <AssignmentIcon color="primary" sx={{ mr: 1, mt: 0.5 }} />
                          <Box>
                            <Typography variant="subtitle2" gutterBottom>
                              分配給
                            </Typography>
                            <Typography variant="body2">
                              {selectedOrder.assignedTo || '尚未分配'}
                            </Typography>
                            {selectedOrder.scheduledDate && (
                              <Typography variant="body2" color="text.secondary">
                                預定時間: {moment(selectedOrder.scheduledDate).format('YYYY/MM/DD HH:mm')}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
                
                <Grid item xs={12} md={5}>
                  <Typography variant="subtitle1" gutterBottom>
                    工作時間線
                  </Typography>
                  <Paper variant="outlined" sx={{ p: 2, height: '100%', maxHeight: 400, overflow: 'auto' }}>
                    {selectedOrder.timeline.map((event, index) => (
                      <Box key={index} sx={{ mb: 2, pb: 2, borderBottom: index < selectedOrder.timeline.length - 1 ? '1px dashed #ddd' : 'none' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                          <Typography variant="subtitle2">
                            {event.status === 'reported' ? '報告問題' :
                             event.status === 'in_progress' ? '開始處理' :
                             event.status === 'scheduled' ? '安排時間' :
                             event.status === 'completed' ? '完成工作' :
                             getStatusName(event.status)}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {moment(event.timestamp).format('MM/DD HH:mm')}
                          </Typography>
                        </Box>
                        <Typography variant="body2">
                          {event.comments}
                        </Typography>
                      </Box>
                    ))}
                  </Paper>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              {selectedOrder.status !== 'completed' && selectedOrder.status !== 'cancelled' && (
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleOpenUpdateDialog}
                >
                  更新狀態
                </Button>
              )}
              <Button onClick={handleCloseDialog}>關閉</Button>
            </DialogActions>
          </>
        )}
      </Dialog>
      
      {/* 狀態更新對話框 */}
      <Dialog open={updateDialogOpen} onClose={handleCloseUpdateDialog} maxWidth="sm" fullWidth>
        {selectedOrder && (
          <>
            <DialogTitle>更新工作訂單狀態</DialogTitle>
            <DialogContent>
              <Typography variant="subtitle2" gutterBottom>
                工作訂單 #{selectedOrder.id}: {selectedOrder.title}
              </Typography>
              
              <FormControl fullWidth margin="normal">
                <InputLabel>狀態</InputLabel>
                <Select
                  value={statusUpdate}
                  label="狀態"
                  onChange={(e) => setStatusUpdate(e.target.value)}
                >
                  <MenuItem value="pending">待處理</MenuItem>
                  <MenuItem value="in_progress">處理中</MenuItem>
                  <MenuItem value="scheduled">已排程</MenuItem>
                  <MenuItem value="completed">已完成</MenuItem>
                  <MenuItem value="cancelled">已取消</MenuItem>
                </Select>
              </FormControl>
              
              <TextField
                fullWidth
                label="備註/說明"
                multiline
                rows={4}
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                margin="normal"
                placeholder="請添加相關說明或進度更新"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseUpdateDialog}>取消</Button>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={handleUpdateOrder}
                disabled={statusUpdate === selectedOrder.status && !comments.trim()}
              >
                更新
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default WorkOrder; 